/** Копия объекта без undefined-полей; если полей не осталось — undefined.
 *  Не зависит от набора ключей: работает для любых объектов (в т.ч. с новыми полями). */
export function stripUndefined<T extends object>(value: T): T | undefined {
  const filtered = Object.fromEntries(
    Object.entries(value as Record<string, unknown>)
      .filter(([, item]) => item !== undefined),
  );

  return Object.keys(filtered).length > 0 ? filtered as T : undefined;
}
